"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.484 15.838a.497.497 0 0 0 .545-.112l3.378-3.43h6.058v-1H5.198a.505.505 0 0 0-.357.149l-2.668 2.71V5.759h8.786v1.303c0 .131.052.257.144.351l2.866 2.911a.502.502 0 0 0 .857-.351V.855a.732.732 0 0 0-.73-.73H5.044a.73.73 0 0 0-.73.73v3.516h1V1.125h8.512v7.627L11.96 6.857V5.496a.737.737 0 0 0-.737-.737H1.91a.738.738 0 0 0-.737.737v9.879a.5.5 0 0 0 .311.463Zm3.417-6.601a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.976 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.477-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.136 23.77a.556.556 0 0 0 .614-.125l5.211-5.292h9.325v-1.125h-9.56a.56.56 0 0 0-.4.167l-4.414 4.482V8.38h13.803v2.188c0 .148.058.29.162.394l4.373 4.441a.561.561 0 0 0 .963-.394V1.1a.915.915 0 0 0-.914-.913H7.491a.914.914 0 0 0-.913.913v5.363h1.125V1.312h13.385v12.325l-3.248-3.298V8.18a.925.925 0 0 0-.924-.924H2.711a.925.925 0 0 0-.924.924v15.07a.56.56 0 0 0 .35.52Zm5.137-9.896a.75.75 0 1 0 0-1.501.75.75 0 0 0 0 1.5Zm3.015 0a.75.75 0 1 0 0-1.501.75.75 0 0 0 0 1.5Zm3.765-.75a.75.75 0 1 1-1.5-.001.75.75 0 0 1 1.5 0Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.848 31.694a.748.748 0 0 0 .818-.168l6.95-7.055h12.432v-1.5H10.301a.747.747 0 0 0-.534.223l-5.885 5.975V11.175h18.404v2.917a.75.75 0 0 0 .216.526l5.831 5.921a.748.748 0 0 0 1.284-.526V1.468A1.22 1.22 0 0 0 28.4.25H9.99c-.675 0-1.22.546-1.22 1.218v7.151h1.5V1.75h17.847v16.432l-4.33-4.397v-2.878c0-.679-.553-1.232-1.232-1.232H3.615c-.68 0-1.233.553-1.233 1.232V31c0 .305.184.579.466.694Zm6.85-13.196a1 1 0 1 0-.002-2 1 1 0 0 0 .001 2Zm4.02 0a1 1 0 1 0-.001-2 1 1 0 0 0 0 2Zm5.02-1a1 1 0 1 1-2.001 0 1 1 0 0 1 2 0Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.029 47.743a.932.932 0 0 0 1.023-.21l10.622-10.786H34.66v-1.875H15.282c-.251 0-.492.1-.668.28L5.32 44.587V16.536h28.383v4.636c0 .247.096.483.27.657l8.863 9a.937.937 0 0 0 1.605-.657V1.982c0-.909-.74-1.649-1.65-1.649H14.807c-.91 0-1.649.74-1.649 1.65v10.87h1.875V2.208h27.535v25.676l-6.989-7.096V16.33a1.67 1.67 0 0 0-1.669-1.67H5.117c-.921 0-1.67.748-1.67 1.67v30.544a.94.94 0 0 0 .582.868Zm10.334-20.08a1.312 1.312 0 1 0 0-2.625 1.312 1.312 0 0 0 0 2.625Zm6.111 0a1.313 1.313 0 1 0 0-2.626 1.313 1.313 0 0 0 0 2.626Zm7.424-1.313a1.313 1.313 0 1 1-2.626 0 1.313 1.313 0 0 1 2.626 0Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.372 63.657a1.247 1.247 0 0 0 1.364-.28L20.9 48.996h25.313v-2.5H20.376c-.335 0-.656.134-.89.373l-12.39 12.58V22.048h37.842v6.181c0 .329.13.644.36.877l11.818 12a1.25 1.25 0 0 0 2.14-.876V2.643A2.202 2.202 0 0 0 57.057.444H19.741a2.201 2.201 0 0 0-2.198 2.199v14.494h2.5V2.944h36.713v34.235l-9.318-9.462v-5.943a2.228 2.228 0 0 0-2.226-2.226H6.822a2.229 2.229 0 0 0-2.227 2.226V62.5c0 .508.308.964.777 1.157Zm13.779-26.773a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Zm8.148 0a1.75 1.75 0 1 0-.001-3.501 1.75 1.75 0 0 0 .001 3.5Zm9.899-1.75a1.75 1.75 0 1 1-3.502-.001 1.75 1.75 0 0 1 3.502 0Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconChat = function IconChat(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Chat' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Chat"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconChat.sizes = [16, 24, 32, 48, 64];
IconChat.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconChat;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Chat.js
// module id = 1681
// module chunks = 0